export default function SignalDots({ strength = 0, size = "md" }) {
  const dots = [1, 2, 3, 4, 5];
  const dim = size === "sm" ? "h-1.5 w-1.5" : "h-2 w-2";
  return (
    <div
      data-testid={`signal-strength-${strength}`}
      className="flex items-center gap-1"
      aria-label={`Signal strength ${strength} of 5`}
    >
      {dots.map((d) => (
        <span
          key={d}
          className={`${dim} rounded-full transition-colors ${
            d <= strength ? "bg-[#3b82f6]" : "bg-[#1e293b]"
          }`}
        />
      ))}
    </div>
  );
}
